import type { PriceInfo } from "epsm-api-types/ws";
import type { UTCTimestamp } from "lightweight-charts";
import type {
	IContext,
	PineJS,
	StudyMetaInfo,
} from "@/charting_library/charting_library";
import { chartColors } from "@/components/widgets/Chart/const";
import { Datasets } from "@/components/widgets/Chart/types";
import type { RevisionExt } from "@/components/widgets/Revision/types";
import { RevisionsIndicatorService } from "./RevisionsIndicatorService";

export class RSEpsZacksIndicatorService extends RevisionsIndicatorService {
	fieldMapper(item: RevisionExt): PriceInfo<UTCTimestamp> {
		return {
			time: item.date.getTime(),
			close: item.rs?.ns,
		} as PriceInfo<UTCTimestamp>;
	}

	get requiredFields() {
		return ["rs.ns"];
	}

	getPlotsData(PineJS: PineJS, context: IContext): number[] {
		const indicator = PineJS.Std.close(context);

		return [indicator];
	}

	get styles() {
		return {
			plot_0: {
				title: Datasets.RSEZ,
				histogramBase: 0,
			},
		};
	}

	get defaults(): StudyMetaInfo["defaults"] {
		return {
			styles: {
				plot_0: {
					plottype: 0,
					linestyle: 0,
					visible: true,
					transparency: 0,
					color: chartColors.up,
				},
			},
		};
	}
}
